import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'

//Pgm_list_info Detail
export const rewardAction = () => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REWARD
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_REWARD, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}

// Create Reward
export const postrewardAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_REWARD
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_CREATE_REWARD, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)})
}

//Reward Redeem List APi
export const getrewardredeemAction = (page, params) => dispatch => {
  var url = process.env.REACT_APP_API_URL + Url.REWARD_REDEEM + "?" + `page=${page}&page_size=10` + (params ? `&product_code=${params}` : '');
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_REWARD_REDEEM_LIST, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}

export const searchdataRewardredeem = (params = {}) => dispatch => {
  dispatch({ type: types.SEARCH_DATA_REWARD_REDEEM, payload: params ? { data: params } : null })
}
// FAQ page
export const pagedataRewardredeem = (params = {}) => dispatch => {
  dispatch({ type: types.PAGE_DATA_REWARD_REDEEM, payload: params ?  params  : null })
}

// Create Reward Redeem post Api
export const postrewardredeemAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_REWARD_REDEEM
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_CREATE_REWARD_REDEEM, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      error?.response?.data?.message?.product_name && notify.error(error?.response?.data?.message?.product_name);
      error?.response?.data?.error && notify.error(error?.response?.data?.error);
    }else{
      errorHandler(error)
    }
    return error?.response;
  })
}

//product_code_mapping  Detail Api
export const productcodemappingDetailAction = (product_code_mapping_id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.REWARD_REDEEM_DETAIL+"/"+product_code_mapping_id
  let options = Object.assign({ method: 'GET'})
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_REWARD_REDEEM_DETAIL, payload: resp })
      return resp
    } else { return null } })
    .catch(error => {
      errorHandler(error)
  })
}

// Edit Reward Redeem post Api
export const posteditrewardredeemAction = (params = {},id) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_EDIT_REWARD_REDEEM+"/"+id
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_EDIT_REWARD_REDEEM, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)})
}